<template>
  <div class="user-details">
    <v-list-item v-for="(item, index) in details" :key="index" class="px-0">
      <v-list-item-content class="py-0 pt-1">
        <v-list-item-title class="caption font-weight-bold">{{
          item.label
        }}</v-list-item-title>

        <v-list-item-subtitle v-if="[2, 3].includes(index)">
          <span class="d-flex">
            <v-icon :color="getActiveUserIconColor(item.value)">
              {{ getActiveUserIcon(item.value) }}
            </v-icon>
          </span>
        </v-list-item-subtitle>
        <v-list-item-subtitle v-else>{{ item.value }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
import { EvercamLabsApi } from "@evercam/shared/api/evercamLabsApi"

export default {
  props: {
    userDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      userPosthogDetails: null,
    }
  },
  computed: {
    details() {
      return [
        {
          label: "Email",
          value: this.userPosthogDetails?.email ?? "-",
        },
        {
          label: "Created At",
          value: this.userPosthogDetails?.createdAt
            ? this.formatDate(this.userPosthogDetails?.createdAt)
            : "-",
        },
        {
          label: "W.A.U",
          value: this.userPosthogDetails?.isWeeklyActiveUser == 1,
        },
        {
          label: "M.A.U",
          value: this.userPosthogDetails?.isMonthlyActiveUser == 1,
        },
        {
          label: "First seen",
          value: this.userPosthogDetails?.earliestEventTimestamp
            ? this.formatDate(this.userPosthogDetails?.earliestEventTimestamp)
            : "-",
        },
        {
          label: "First seen browser",
          value:
            this.userPosthogDetails?.earliestEventOs &&
            this.userPosthogDetails?.earliestEventBrowser
              ? `${this.userPosthogDetails.earliestEventBrowser} on ${this.userPosthogDetails.earliestEventOs}`
              : "-",
        },
        {
          label: "First seen IP",
          value: this.userPosthogDetails?.earliestEventIp ?? "-",
        },
        {
          label: "First seen Event",
          value: this.userPosthogDetails?.earliestEventName
            ? this.userPosthogDetails.earliestEventName.startsWith("$")
              ? this.userPosthogDetails.earliestEventName.substring(1)
              : this.userPosthogDetails.earliestEventName
            : "-",
        },
        {
          label: "Last seen",
          value: this.userPosthogDetails?.latestEventTimestamp
            ? this.formatDate(this.userPosthogDetails?.latestEventTimestamp)
            : "-",
        },
        {
          label: "Last seen browser",
          value:
            this.userPosthogDetails?.latestEventOs &&
            this.userPosthogDetails?.latestEventBrowser
              ? `${this.userPosthogDetails.latestEventBrowser} on ${this.userPosthogDetails.latestEventOs}`
              : "-",
        },
        {
          label: "Last seen IP",
          value: this.userPosthogDetails?.latestEventIp ?? "-",
        },
        {
          label: "Last seen Event",
          value: this.userPosthogDetails?.latestEventName
            ? this.userPosthogDetails.latestEventName.startsWith("$")
              ? this.userPosthogDetails.latestEventName.substring(1)
              : this.userPosthogDetails.latestEventName
            : "-",
        },
      ]
    },
  },
  watch: {
    "userDetails.email"() {
      this.fetchUserEvents()
    },
  },
  async mounted() {
    await this.fetchUserPosthogDetails()
  },
  methods: {
    async fetchUserPosthogDetails() {
      if (!this.userDetails.email) {
        return
      }

      try {
        this.loading = true
        const params = {
          email: this.userDetails.email,
        }
        const response = await EvercamLabsApi.posthog.getUsers(params)

        const element = response.data ?? {}

        // Format item attributes to be usable in the data-table
        if (element) {
          element.latestEventBrowser = element.latestEventProperties.$browser
          element.latestEventOs = element.latestEventProperties.$os
          element.latestEventIp = element.latestEventProperties.$ip
          element.earliestEventBrowser =
            element.earliestEventProperties.$browser
          element.earliestEventOs = element.earliestEventProperties.$os
          element.earliestEventIp = element.earliestEventProperties.$ip
        }

        this.userPosthogDetails = element
      } catch (error) {
        if (error.response?.status === 404) {
          this.loading = false

          return
        }

        this.$notifications.error({
          text: "Could not load Posthog User Details!",
          error,
        })
      } finally {
        this.loading = false
      }
    },
    getActiveUserIcon(isActive) {
      return isActive ? "fa-check" : "fa-times"
    },
    getActiveUserIconColor(isActive) {
      return isActive ? "green" : "red"
    },
  },
}
</script>

<style lang="scss">
.user-details {
  display: flex;
  flex-wrap: wrap;
  .v-list-item {
    margin-bottom: 5px;
    min-height: 0px !important;
    flex: 1 1 25%;
  }
}
</style>
